import React, {Component} from 'react'
import {
    Form,
    Input,
    Row,
    Col,
    Select,
    Button,
    Popconfirm,
    Table, message
} from 'antd';
import {baseUrl, reqAddCompany, reqCompanyList, reqUpdateCompany,reqResetPwd,reqResetEnt} from '../../api'
import {Link} from 'react-router-dom'
import CompanyModal from './company-model'
import LinkButton from '../../components/link-button'
import moment from 'moment';
import 'moment/locale/zh-cn';
import authorizeBase from "../../components/authorize/authorizeBase";
const AuthButton = authorizeBase(Button)
const AuthLinkButton = authorizeBase(LinkButton)

moment.locale('zh-cn');
const {Option} = Select;

const orderStatus = {
    Y: '启用',
    N: '停用',
};

class CompanyList extends Component {

    state = {
        total: 0, // 商品的总数量
        companyList: [], // 商品的数组
        pageNum: 1,
        deviceView:false,
        action:'',
        companyId:''
    }

    /*
     初始化table的列的数组
     */
    initColumns = () => {

    }

    componentWillMount() {
        this.initColumns()
    }

    getProducts = async (pageNum) => {
        const pageSize = 10
        this.setState({
            pageNum: pageNum// 保存pageNum, 让其它方法可以看到
        })
        const {getFieldsValue} = this.props.form
        const values = getFieldsValue();
        values.pageNum = pageNum;
        values.pageSize = pageSize;
        let result = await reqCompanyList(values)
        if (result.code === 200) {
            this.setState({
                total: result.data.total,
                companyList: result.data.rows
            })
        } else if (result.code === 401) {
            this.props.history.replace('/login')
        } else {

        }

    }

    onRef = (ref) => {
        this.child = ref
    }

    componentDidMount() {
        this.getProducts(1)
    }

    /*查询列表*/
    handleSubmit = e => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            values.pageNum = 1
            values.pageSize = 10;
            this.setState({
                pageNum:values.pageNum
            })
            if (!err) {
                this.reqCompanyList(values);
            }
        });
    };

    reqCompanyList = async (po) => {
        const result = await reqCompanyList(po);
        if (result.code === 200) {
            this.setState({
                total: result.data.total,
                companyList: result.data.rows
            })
            this.initColumns()
        } else {
            message.error(result.message);
        }
    };


    handleTableChange = (pagination, filters, sorter) => {
        const pager = { ...this.state.pagination };
        pager.current = pagination.current;
        this.setState({
            pagination: pager,
        });
        const pageNum = pagination.current
        this.getProducts(pageNum)
    };

    // 新增

    addDevice = () => {
        this.setState({
            deviceView: true,
            action:'add',
        })
    }

    // 修改
    updateDevice =(data) => {
        this.setState({
            deviceView: true,
            action:'update',
            companyId: data.id
        })
        this.child.props.form.setFieldsValue(data);
    }

    // 新增
    getAddCompany = async (po) => {
        const {pageNum} = this.state
        const result = await reqAddCompany(po);
        if (result.code === 201) {
            this.getProducts(pageNum)
            message.success("新增成功，初始密码为123456");
        } else {
            message.error(result.message);
        }
    };

    // 更新
    getUpdateCompany = async (po) => {
        const {pageNum} = this.state
        const result = await reqUpdateCompany(po);
        if (result.code === 200) {
            this.getProducts(pageNum)
        } else {
            message.error(result.message);
        }
    };
    // 重置密码
    getResetPwd = async (id) => {
        const data = {
            id
        }
        const {pageNum} = this.state
        const result = await reqResetPwd(data);
        if (result.code === 200) {
            this.getProducts(pageNum)
        } else {
            message.error(result.message);
        }
    };
    // 启用/停用
    getResetEnt = async (po) => {
        let sts = po.sts
        if(sts==='Y'){
            sts='N'
        }else{
            sts='Y'
        }
        const data = {
            id:po.id,
            sts:sts
        }
        const {pageNum} = this.state
        const result = await reqResetEnt(data);
        if (result.code === 200) {
            this.getProducts(pageNum)
        } else {
            message.error(result.message);
        }
    };


    onOk = data => {
        const {action,companyId} = this.state;
        if (action === 'add') {
            this.getAddCompany(data)
            this.setState({deviceView: false});
        } else {
            const updateData = {
                ...data,
                id:companyId
            }
            this.getUpdateCompany(updateData)
            this.setState({deviceView: false});
            /*const newData = [...this.state.tableData];
            const index = newData.findIndex(item => data.key === item.key);
            if (index > -1) {
                const item = newData[index];
                newData.splice(index, 1, {
                    ...item,
                    ...data,
                });
                this.setState({tableData: newData, visible: false,});
            }*/
        }
        console.log(data)
    }

    onCancel = () => {
        this.setState({
            deviceView: false
        })
    }


    render() {
        const form = this.props.form
        const {getFieldDecorator} = form;

        const formItemLayout = {
            labelCol: {
                xs: {span: 9},
                sm: {span: 9},
            },
            wrapperCol: {
                xs: {span: 13},
                sm: {span: 13},
            },
        }

        const rowSelection = {
            onChange: (selectedRowKeys, selectedRows) => {
                console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
            },
            getCheckboxProps: record => ({
                disabled: record.name === 'Disabled User', // Column configuration not to be checked
                name: record.name,
            }),
        }

        // 取出状态数据
        const {companyList, total,deviceView} = this.state
        const columns = [
            {
                title: '揽收单位',
                dataIndex: 'name',
                width: '10%'
            },
            {
                title: '企业简称',
                dataIndex: 'shortName',
            },
            {
                title: '联系人',
                dataIndex: 'linkMan',
            },
            {
                title: '联系电话',
                dataIndex: 'linkPhone',
            },
            {
                title: '登录账号',
                dataIndex: 'userName'
            }, {
                title: '状态',
                dataIndex: 'sts',
                render: (text, record) => (
                    <span>
                        {orderStatus[text]}
                    </span>
                )
            }, {
                title: '操作',
                dataIndex: 'opt',
                fixed: 'right',
                width: 250,
                render: (text, record) => {
                    if(record.sts==='Y'){
                        return <span>
                            <AuthLinkButton authority="ent:update"
                                   onClick={() => this.updateDevice(record)}>修改</AuthLinkButton>
                            <AuthLinkButton authority="ent:reset_ent"
                                        onClick={() => this.getResetEnt(record)}>停用</AuthLinkButton>
                            <Popconfirm title="是否确认重置密码为123456?" onConfirm={() => this.getResetPwd(record.id)}>
                                <AuthLinkButton authority="ent:reset_pwd" >重置密码</AuthLinkButton>
                            </Popconfirm>
                        </span>
                    }else{
                        return <span>
                            <AuthLinkButton authority="ent:update"
                                   onClick={() => this.updateDevice(record)}>修改</AuthLinkButton>
                            <AuthLinkButton authority="ent:reset_ent"
                                   onClick={() => this.getResetEnt(record)}>启用</AuthLinkButton>
                            <Popconfirm title="是否确认重置密码为123456?" onConfirm={() => this.getResetPwd(record.id)}>
                                <AuthLinkButton authority="ent:reset_pwd" >重置密码</AuthLinkButton>
                            </Popconfirm>
                        </span>
                    }

                }
            }
        ];

        return (
            <div className='box-shadow padding-20'>
                <div className='head-title'>企业列表</div>
                <br/>
                <Form {...formItemLayout} onSubmit={this.handleSubmit}>
                    <Row>
                        <Col span={6}>
                            <Form.Item label="揽收单位">
                                {getFieldDecorator('name', {})(<Input />)}
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item label="企业简称">
                                {getFieldDecorator('shortName', {})(<Input />)}
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item label="联系人">
                                {getFieldDecorator('linkMan', {})(<Input />)}
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item label="联系电话">
                                {getFieldDecorator('linkPhone', {})(<Input />)}
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item label="状态">
                                {getFieldDecorator('sts', {
                                    initialValue: '',
                                })(<Select getPopupContainer={triggerNode => triggerNode.parentNode}>
                                    <Option value="">全部</Option>
                                    <Option value="Y">启用</Option>
                                    <Option value="N">停用</Option>
                                </Select>)}
                            </Form.Item>
                        </Col>
                        <Col span={6} style={{float: 'right', marginBottom: '20px'}}>
                            <Button type='primary' htmlType="submit"
                                    style={{float: 'right', marginRight: '16.7%'}}>查询</Button>
                            <AuthButton authority="ent:add" type="primary" onClick={this.addDevice}>新增</AuthButton>
                        </Col>
                    </Row>
                </Form>

                <Table
                    rowSelection={rowSelection}
                    columns={columns}
                    bordered
                    dataSource={companyList}
                    rowKey='id'
                    onChange={this.handleTableChange}
                    pagination={{
                        current: this.state.pageNum,
                        total: total,
                        showQuickJumper: true,
                    }}
                    size="middle"
                />
                <CompanyModal
                    onRef={this.onRef}
                    onOk={this.onOk}
                    action={this.state.action}
                    deviceView={deviceView}
                    onCancel={this.onCancel}
                />
            </div>

        )
    }
}
const CompanyListFrom = Form.create()(CompanyList)
export default CompanyListFrom